import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-base pt-8 mb-6" }
const _hoisted_2 = { class: "flex flex-row gap-5 pl-0" }
const _hoisted_3 = ["onClick"]

import { computed, ref, onMounted } from "vue";
import PageHeaderComponent from "@/components/global/PageHeaderComponent.vue";
import EditSelectionComponent from "@/modules/main/components/internal-tools/EditSelectionComponent.vue";
import ArchiveSelectionComponent from "@/modules/main/components/internal-tools/ArchiveSelectionComponent.vue";
import AddSchoolComponent from "@/modules/main/components/internal-tools/AddSchoolComponent.vue";
import CreateSchoolGroupComponent from "@/modules/main/components/internal-tools/CreateSchoolGroupComponent.vue";
import TrackSelectionComponent from "@/modules/main/components/internal-tools/TrackSelectionComponent.vue";
import ActivityLogsInternalView from "@/modules/main/views/internal/ActivityLogsInternalView.vue";
import InternalAdminsView from "@/modules/main/views/internal/InternalAdminsView.vue";
import PublicAPIKeysComponent from "@/modules/main/components/internal-tools/PublicAPIKeysComponent.vue";
import RegionMoveComponent from "@/modules/main/components/internal-tools/RegionMoveComponent.vue";
import { useLearnerStore } from "@/stores/learnerStore";
import { useUserStore } from "@/stores/userStore";
import { useActivityLogStore } from "@/stores/activityLogStore";
import { InternalAdmin } from "@/stores/internalAdminStore";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'InternalView',
  setup(__props) {

const learnerStore = useLearnerStore();
const userStore = useUserStore();
const activityLogStore = useActivityLogStore();
const router = useRouter();
const route = useRoute();
const btnOption = ref("Edit");

const applyTabFromQuery = (rawTab: unknown) => {
  if (typeof rawTab !== "string" || !rawTab) return;
  if (options.value.includes(rawTab)) {
    btnOption.value = rawTab;
  }
};
const options = computed(() => {
  const baseOptions = ["Create", "Add", "Edit", "Track", "Archive"];

  if (userStore.isInternalAdmin) {
    return [...baseOptions, "ActivityLogs", "InternalAdmins", "APIKeys", "RegionMoves"];
  }

  return baseOptions;
});

const setOption = (option: string) => {
  btnOption.value = option;
  learnerStore.setArchiveOptions(false);
};

const handleGoToActivityLogs = (admin: InternalAdmin) => {
  activityLogStore.setFilters({
    adminIds: [admin._id],
    actionTypes: [],
    entityTypes: [],
    startDate: "",
    endDate: "",
    includeAllSchoolsForAdmin: true,
  });
  btnOption.value = "ActivityLogs";
};

onMounted(() => {

  // Route to admin if the user is not an internal admin
  if (!userStore.isInternalAdmin) {
    router.push("/main/admin");
    return;
  }

  if (learnerStore.archiveOptions) {
    btnOption.value = "Archive";
  }

  applyTabFromQuery(route.query.tab);
});

onBeforeRouteUpdate((to) => {
  applyTabFromQuery(to.query.tab);
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageHeaderComponent, {
      pageHeading: 'Internal',
      filterVariant: "gradeSubject",
      includeAll: true
    }),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (option) => {
          return (_openBlock(), _createElementBlock("button", {
            key: option,
            class: _normalizeClass(["px-4 py-2 rounded-lg transition-colors duration-300", {
                'bg-blue-600 text-white': btnOption.value === option,
                'bg-transparent text-gray-700 hover:bg-gray-100': btnOption.value !== option
        }]),
            onClick: ($event: any) => (setOption(option))
          }, _toDisplayString(_ctx.$t(`internal_tools.top_bar.${option.toLowerCase()}`)), 11, _hoisted_3))
        }), 128))
      ])
    ]),
    (btnOption.value === 'Create')
      ? (_openBlock(), _createBlock(CreateSchoolGroupComponent, { key: 0 }))
      : _createCommentVNode("", true),
    (btnOption.value === 'Add')
      ? (_openBlock(), _createBlock(AddSchoolComponent, { key: 1 }))
      : _createCommentVNode("", true),
    (btnOption.value === 'Edit')
      ? (_openBlock(), _createBlock(EditSelectionComponent, { key: 2 }))
      : _createCommentVNode("", true),
    (btnOption.value === 'Archive')
      ? (_openBlock(), _createBlock(ArchiveSelectionComponent, { key: 3 }))
      : _createCommentVNode("", true),
    (btnOption.value === 'Track')
      ? (_openBlock(), _createBlock(TrackSelectionComponent, { key: 4 }))
      : _createCommentVNode("", true),
    (btnOption.value === 'ActivityLogs')
      ? (_openBlock(), _createBlock(ActivityLogsInternalView, { key: 5 }))
      : _createCommentVNode("", true),
    (btnOption.value === 'InternalAdmins')
      ? (_openBlock(), _createBlock(InternalAdminsView, {
          key: 6,
          onGoToActivityLogs: handleGoToActivityLogs
        }))
      : _createCommentVNode("", true),
    (btnOption.value === 'APIKeys')
      ? (_openBlock(), _createBlock(PublicAPIKeysComponent, { key: 7 }))
      : _createCommentVNode("", true),
    (btnOption.value === 'RegionMoves')
      ? (_openBlock(), _createBlock(RegionMoveComponent, { key: 8 }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})